import { PrinterPosEditOutlineIcon } from './PrinterPosEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 401FC546-94DF-4C01-9B08-24EEB602A4C3
 * name printer-pos-edit-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-edit-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptEditOutlineIcon = PrinterPosEditOutlineIcon;
export default PrinterReceiptEditOutlineIcon